import {
  Badge,
  Button,
  Card,
  Divider,
  Flex,
  Heading,
  Text,
} from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import { useImmunizationsQuery } from "./api/useImmunizationsQuery";
import StatusCheckComponent from "../common/StatusCheckComponent";
import { useUserQuery } from "../common/useUserQuery";
import CareNotesCard from "../common/CareNotesCard";

export default function ImmunizationsContainer() {
  const navigate = useNavigate();
  const { data: userQueryData } = useUserQuery();
  const {
    data: immunizationResults,
    isFetching,
    error,
  } = useImmunizationsQuery(userQueryData?.patientUserId);

  if (isFetching) return "Loading...";

  if (error) return "An error happened, try refreshing the browser.";

  return immunizationResults?.map((immunization) => {
    let detailsTags = [];
    try {
      detailsTags = JSON.parse(immunization?.detailsTags || "[]");
      if (!Array.isArray(detailsTags)) {
        detailsTags = [];
      }
    } catch (error) {
      console.error("Error parsing detailsTags:", error);
      detailsTags = [];
    }
    return (
      <Card variation="elevated" key={`ic_ir_${immunization?.id}`}>
        <Flex direction="row" alignItems="center">
          <Heading
            level="5"
            children={immunization?.immunizationName}
          ></Heading>
          <Button
            size="small"
            variation="primary"
            onClick={() =>
              navigate(`/user/hr/immunizations/${immunization.id}/edit`)
            }
          >
            Edit
          </Button>
        </Flex>
        <Flex marginTop={12}>
          <Badge size="small" variation="info">
            Administered Dates: {immunization?.administeredDates}
          </Badge>
        </Flex>
        <Flex marginTop={12} wrap={"wrap"}>
          <Flex
            justifyContent={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Badge size="small">
              Administered Location: {immunization?.administeredLocation}
            </Badge>
            <Badge size="small">Method: {immunization?.method}</Badge>
            <Badge size="small">Dosage: {immunization?.dosage}</Badge>
            {detailsTags?.map((tag, index) => (
              <Badge key={index} size="small">
                {tag}
              </Badge>
            ))}
          </Flex>
        </Flex>
        <Flex marginTop={12}>
          <Text fontWeight={800}>Description:</Text>
          <Text>{immunization?.immunizationDescription}</Text>
        </Flex>
        <Flex direction={"column"} marginTop={12}>
          <CareNotesCard
            noteSection="HR_IMMUNIZATIONS"
            objectId={immunization?.id}
          />
        </Flex>
        <Flex marginTop={9} direction="column">
          <Divider size="small" />
          <StatusCheckComponent
            label={`Last Update: ${immunization?.updatedAt || ""}`}
          />
        </Flex>
      </Card>
    );
  });
}
